import { Ionicons } from '@expo/vector-icons';
import { BOOKING_STATUS } from '@/types/service';

/**
 * O que cada estado significa para o prestador e o que ele faz a seguir. Fonte
 * única da copy: card, detalhe e agenda dizem a mesma coisa e mandam para o
 * mesmo lugar.
 */
export interface BookingStatusCopy {
  label: string;
  hint: string;
  icon: keyof typeof Ionicons.glyphMap;
  /** `null` quando não há nada a resolver. */
  action: { label: string; href: string } | null;
  tone: 'ok' | 'warning' | 'muted';
}

const SCHEDULE_SETTINGS = '/(tabs)/(provider)/schedule/settings';

export const BOOKING_STATUS_COPY: Record<BOOKING_STATUS, BookingStatusCopy> = {
  [BOOKING_STATUS.BOOKABLE]: {
    label: 'Agendável online',
    hint: 'Seus clientes conseguem marcar horário neste serviço.',
    icon: 'checkmark-circle',
    action: null,
    tone: 'ok',
  },
  [BOOKING_STATUS.CUSTOM_DURATION]: {
    label: 'Sob medida',
    hint: 'O tempo é acertado em cada contrato — você marca, o cliente não marca sozinho.',
    icon: 'construct-outline',
    action: null,
    tone: 'muted',
  },
  [BOOKING_STATUS.NO_GRID]: {
    label: 'Sem horários de atendimento',
    hint: 'Marque os dias e faixas em que você atende — é isso que abre a agenda.',
    icon: 'calendar-outline',
    action: { label: 'Definir horários', href: SCHEDULE_SETTINGS },
    tone: 'warning',
  },
  [BOOKING_STATUS.PAUSED]: {
    label: 'Agenda pausada',
    hint: 'Há uma pausa sem data de fim em vigor. Remova o bloqueio para voltar a receber.',
    icon: 'pause-circle-outline',
    action: { label: 'Ver bloqueios', href: SCHEDULE_SETTINGS },
    tone: 'warning',
  },
  [BOOKING_STATUS.INACTIVE]: {
    label: 'Serviço desativado',
    hint: 'Desativado não aparece para clientes nem na sua agenda.',
    icon: 'eye-off-outline',
    action: null,
    tone: 'muted',
  },
};

export const BOOKING_STATUS_TONE: Record<
  BookingStatusCopy['tone'],
  { background: string; foreground: string }
> = {
  ok: { background: '#DCFCE7', foreground: '#15803D' },
  warning: { background: '#FEF3C7', foreground: '#B45309' },
  muted: { background: '#F5F5F5', foreground: '#737373' },
};
